import {Notification} from "element-ui";

// 版本标识缓存
let versionTag = null;
// 标记是否已经弹出更新弹窗，防止重复弹出
let isShowUpdateNotify = false;
let NotifyInstance = null;

// 更新页面逻辑
const onUpdateSystem = () => {
    window.location.reload();
};

// 全局事件委托：监听更新弹窗按钮点击（只绑定一次）
if (!window.__versionNotifyBind) {
    window.__versionNotifyBind = true;
    document.addEventListener("click", e => {
        const target = e.target;
        // 立即更新按钮
        if (target.dataset.action === "confirm-update") {
            onUpdateSystem();
            isShowUpdateNotify = false;
        }
        // 稍后再说按钮
        if (target.dataset.action === "cancel-update") {
            isShowUpdateNotify = false;
            NotifyInstance && NotifyInstance.close();
        }
    });
}

// 提示用户更新弹窗（纯JS可用，不需要传入组件this）
const handleNotification = () => {
    // 已弹出直接返回，避免重复弹窗
    if (isShowUpdateNotify) return;

    NotifyInstance = Notification.info({
        title: "新版本更新",
        duration: 0,
        position: "bottom-right",
        dangerouslyUseHTMLString: true, // 开启HTML渲染
        message: `
            <div style="line-height: 1.8;">
                <p>当前系统检测到有新的版本，请及时更新</p>
                <div style="margin-top:12px;display:flex;gap:8px;justify-content:flex-end;">
                    <button 
                        data-action="cancel-update"
                        style="padding:2px 10px;border:1px solid #dcdfe6;background:#fff;border-radius:4px;cursor:pointer;font-size:12px;"
                    >稍后再说</button>
                    <button 
                        data-action="confirm-update"
                        style="padding:2px 10px;background:#409EFF;color:#fff;border:none;border-radius:4px;cursor:pointer;font-size:12px;"
                    >立即更新</button>
                </div>
            </div>
        `,
        onClose: () => {
            // 弹窗手动关闭时重置标记
            isShowUpdateNotify = false;
        }
    });

    isShowUpdateNotify = true;
};

/**
 * 获取首页的 ETag 或 Last-Modified 值，作为当前版本标识
 * @returns {Promise<string|null>} 返回 ETag 或 Last-Modified 值
 */
const getVersionTag = async () => {
    try {
        const response = await fetch(location.origin + location.pathname, {
            cache: "no-cache",
            headers: {
                "Cache-Control": "no-cache"
            }
        });
        return (
            response.headers.get("etag") || response.headers.get("last-modified")
        );
    } catch (err) {
        console.warn("获取版本标识失败", err);
        return null;
    }
};

/**
 * 比较当前的 ETag 或 Last-Modified 值与最新获取的值
 */
const compareTag = async () => {
    const newVersionTag = await getVersionTag();
    // 接口异常直接跳过
    if (!newVersionTag) return;

    if (versionTag === null) {
        // 首次进入页面，缓存初始版本号
        versionTag = newVersionTag;
    } else if (versionTag !== newVersionTag) {
        // 版本发生变化，弹出更新提示
        handleNotification();
    }
};

/**
 * 初始化自动版本检测
 * @param {VueRouter} router vue路由实例
 */
export const setUpAutoUpdate = router => {
    router.afterEach(() => {
        // 去掉你原来多余的 handleNotification()，只做版本对比，有变化才弹窗
        compareTag();
    });
};
